module.exports = __webpack_public_path__ + "static/img/MX@3x.d0f52858.jpg";